import { render, staticRenderFns } from "./ques21.vue?vue&type=template&id=f318dfbe"
import script from "./ques21.vue?vue&type=script&lang=js"
export * from "./ques21.vue?vue&type=script&lang=js"
import style0 from "./ques21.vue?vue&type=style&index=0&id=f318dfbe&prod&lang=css"
import style1 from "./ques21.vue?vue&type=style&index=1&id=f318dfbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports